// extracted by mini-css-extract-plugin
export var logo = "_8z-2";
export var logoWrapper = "_8z-1";
export var strip = "_8z-0";